/**
 * The typed refusal every rule in this package throws (APP-ENTITLEMENT-001). A rule never answers a sentence: it
 * answers a CODE, and each surface words it (`web/no-thrown-message-as-copy`). The server package maps a code to a
 * status through `@puffin-core/response-helpers`; this package knows nothing of HTTP.
 *
 * @module @puffin-core/app-catalog/refusal
 */

'use strict';

/** The closed set of codes a catalog rule can refuse with. */
const APP_CATALOG_REFUSAL = Object.freeze({
  ANCHOR_REQUIRED: 'ANCHOR_REQUIRED',
  APP_NOT_ATTACHABLE: 'APP_NOT_ATTACHABLE',
  APP_NOT_SELLABLE: 'APP_NOT_SELLABLE',
  APP_UNKNOWN: 'APP_UNKNOWN',
  DIMENSION_UNKNOWN: 'DIMENSION_UNKNOWN',
  QUANTITY_BELOW_INCLUDED: 'QUANTITY_BELOW_INCLUDED',
  PRICE_NOT_PUBLISHED: 'PRICE_NOT_PUBLISHED',
  PRICE_ENDING_REFUSED: 'PRICE_ENDING_REFUSED',
  CAP_REACHED: 'CAP_REACHED',
  CAP_BELOW_CONSUMED: 'CAP_BELOW_CONSUMED',
});

const APP_CATALOG_REFUSAL_VALUES = Object.freeze(Object.values(APP_CATALOG_REFUSAL));

class AppCatalogRefusal extends Error {
  /**
   * @param {string} code - one of `APP_CATALOG_REFUSAL_VALUES`.
   * @param {Object} [details] - the facts the surface words (keys, quantities); never a sentence.
   */
  constructor(code, details = {}) {
    if (!APP_CATALOG_REFUSAL_VALUES.includes(code)) {
      throw new TypeError(`AppCatalogRefusal: unknown code ${JSON.stringify(code)}`);
    }
    super(code);
    this.name = 'AppCatalogRefusal';
    this.code = code;
    this.details = Object.freeze({ ...details });
  }
}

/**
 * @param {unknown} error
 * @returns {boolean} true when `error` is a refusal this package threw.
 */
function isAppCatalogRefusal(error) {
  return error instanceof AppCatalogRefusal;
}

module.exports = {
  APP_CATALOG_REFUSAL,
  APP_CATALOG_REFUSAL_VALUES,
  AppCatalogRefusal,
  isAppCatalogRefusal,
};
